import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'
import Loader from './Loader'

//components
import TripFlights from '../components/TripFlights'
import TripAddFlight from '../components/TripAddFlight'
import TripItinerary from '../components/TripItinerary'
import TripLuggageNotes from '../components/TripLuggageNotes'
import TripNotes from '../components/TripNotes'
import TripAccomodations from '../components/TripAccomodations'
import TripAddAccomodation from '../components/TripAddAccomodation'
import TripUpdateFlight from '../components/TripUpdateFlight'
import TripUpdateAccomodation from '../components/TripUpdateAccomodation'

const CurrentTripDetails = () => {
    const { trip, flights, activities, accomodations, dispatch} = useCurrentTripContext()
    const {user, isLoading } = useAuthContext()
    const navigate = useNavigate()
    const { trip_id } = useParams()
    const [selector, setSelector] = useState('itinerary')
    const [flightMenu, setFlightMenu] = useState('details')
    const [accomodationMenu, setAccomodationMenu] = useState('details')
    const [selectedFlight, setSelectedFlight] = useState(null)
    const [selectedAccomodation, setSelectedAccomodation] = useState(null)
    

    useEffect(() => {  //code that runs after render //useEffects are side effects that happens when something renders/something changes
        if (isLoading) {
            return <Loader />
        }
        if (!user) {
            console.log('no user')
            navigate('/login')
            return
        } 
        if (!trip_id) {
            console.log('no trip')
            navigate('/dashboard')
            return
        }
        dispatch({type: 'SET_FLIGHTS', payload: null})
        dispatch({type: 'SET_ACTIVITIES', payload: null})
        dispatch({type: 'SET_ACCOMODATIONS', payload: null})
        dispatch({type: 'SET_TRIP', payload: null})
        const fetchTripDetails = async () => {
            //need to check if trip exists
            const trip_response = await fetch(`${process.env.REACT_APP_API_URL}/api/trip/` + trip_id, {
                credentials: 'include'
            })
            const trip_json = await trip_response.json()

            if (!trip_response.ok) {
                console.log('no trip found')
                navigate('/dashboard')
                return
            }
            dispatch({type: 'SET_TRIP', payload: trip_json})
            //fetch flight details and save to CurrentFlightContext
            const flight_response = await fetch(`${process.env.REACT_APP_API_URL}/api/flight/` + trip_id, {
                credentials: 'include'
            }) 
            const flight_json = await flight_response.json() 
        
            if (flight_response.ok) {
                dispatch({type: 'SET_FLIGHTS', payload: flight_json})
            }
            //fetch flight details and save to CurrentFlightContext
            const activity_response = await fetch(`${process.env.REACT_APP_API_URL}/api/activity/` + trip_id, {
                credentials: 'include'
            }) 
            const activity_json = await activity_response.json() 
        
            if (activity_response.ok) {
                dispatch({type: 'SET_ACTIVITIES', payload: activity_json})
            }

            const accomodation_response = await fetch(`${process.env.REACT_APP_API_URL}/api/accomodation/` + trip_id, {
                credentials: 'include'
            }) 
            const accomodation_json = await accomodation_response.json() 
        
            if (accomodation_response.ok) {
                dispatch({type: 'SET_ACCOMODATIONS', payload: accomodation_json})
            }
        }
        fetchTripDetails()
    }, [dispatch, user, isLoading, navigate, trip_id])  //with an empty array it only fires once when the component renders, things like [count] re-runs each time count state changes
    if (!trip || !user || isLoading) {
        return <Loader />
    } else {
        return (
            <div className="current-trip-details">
                <div className="trip-selector-menu">
                    <div className="selector-title">
                        <h3><strong>{trip ? trip.trip_name : ""}</strong></h3>
                    </div>
                    <div className="itinerary-btn" onClick={() => {setSelector("itinerary")}}>
                        <h3>Daily Itinerary</h3>
                    </div>
                    <div className="accomodation-btn" 
                        onClick={() => {
                            setSelector("accomodation")
                            setAccomodationMenu("details")
                            setSelectedAccomodation(null)
                        }}>
                        <h3>Accomodation</h3>
                    </div>
                    <div className="flights-btn" 
                        onClick={() => {
                            setSelector("flights") 
                            setFlightMenu("details")
                            setSelectedFlight(null)
                        }}>
                        <h3>Flights</h3>
                    </div>
                    <div className="luggage-checklist-btn" onClick={() => {setSelector("luggage")}}>
                        <h3>Luggage Notes</h3>
                    </div>
                    <div className="notes-btn" onClick={() => {setSelector("notes")}}>
                        <h3>Notes</h3>
                    </div>
                </div>
                <div className="trip-selected-details">
                    {selector === "notes" && <TripNotes trip={trip}/>}
                    {selector === "flights" && flightMenu === "details" && <TripFlights trip={trip} flights={flights} onAddFlight={setFlightMenu} onEditFlight={setSelectedFlight}/>}
                    {selector === "flights" && flightMenu === "add" && <TripAddFlight trip={trip} flights={flights} onAddFlight={setFlightMenu} />}
                    {selector === "flights" && flightMenu === "edit" && <TripUpdateFlight trip={trip} flight={selectedFlight} onAddFlight={setFlightMenu} />}
                    {selector === "itinerary" && <TripItinerary trip={trip} activities={activities} />}
                    {selector === "luggage" && <TripLuggageNotes trip={trip} />}
                    {selector === "accomodation" && accomodationMenu === "details" && <TripAccomodations trip={trip} accomodations={accomodations} onAddAccomodation={setAccomodationMenu} onEditAccomodation={setSelectedAccomodation}/>}
                    {selector === "accomodation" && accomodationMenu === "add" && <TripAddAccomodation trip={trip} accomodations={accomodations} onAddAccomodation={setAccomodationMenu} />}
                    {selector === "accomodation" && accomodationMenu === "edit" && <TripUpdateAccomodation trip={trip} accomodation={selectedAccomodation} onAddAccomodation={setAccomodationMenu} />}
                </div>
            </div>
        )
    }
    
}

export default CurrentTripDetails